import { BRAND_NAME } from "../../config/constants";

const progs = [

    {
        value: 'Social Cred$ Kids',
        label: `${BRAND_NAME} Kids`
    },
    {
        value: 'Job Cred$',
        label: 'Job Cred$'
    },
    {
        value: 'Seniors',
        label: 'Seniors'
    },
    {
        value: 'Coupon Donation Drive',
        label: 'Coupon Donation Drive'
    }


]


export default progs